import { TableCell, TableRow, Checkbox } from "@mui/material";
import ButtonDesplegable from "../../../../components/Common/ButtonDesplegable";
import DesplegableRubrosProducto from "../DesplegableRubrosProducto";
import { ProductoWProps } from "../Producto";
import ProductoActions from "../ProductoActions";
import { ProductosAdminContext } from "../../context/productos.context";
import { useContext, useMemo } from "react";
import { format } from "date-fns";
import { IProducto } from "../../types/producto";

const TableProducto = ({
  producto,
  rubros,
  cambiarRubro,
  changingEstado,
  isDefinitivelyDeleting,
  isSelected,
  setIsSelected,
  loadingRubros,
}: ProductoWProps) => {
  const {
    setEditProductId,
    setIdLocalEditing,
    productosSeleccionados,
    setProductosSeleccionados,
  } = useContext(ProductosAdminContext);

  const estaSeleccionado = useMemo(() => {
    return productosSeleccionados.some(
      (p: IProducto) => p.idProducto === producto.idProducto
    );
  }, [productosSeleccionados, producto]);

  const handleCheckboxChange = () => {
    if (estaSeleccionado) {
      setProductosSeleccionados(
        productosSeleccionados.filter(
          (p: IProducto) => p.idProducto !== producto.idProducto
        )
      );
    } else {
      setProductosSeleccionados([...productosSeleccionados, producto]);
    }
  };
  return (
    <>
      <TableRow
        style={{
          backgroundColor:
            producto.aprobado && !producto.pausado && !producto.vencido
              ? "#b3faa8"
              : producto.rechazado
              ? "#ffaeba"
              : producto.pausado || producto.vencido
              ? "#ddd"
              : "#fff",
        }}
      >
        <TableCell align="center">
          <Checkbox
            checked={estaSeleccionado}
            onChange={handleCheckboxChange}
            sx={{
              p: 0,
              m: 0,
              width: "fit-content",
              alignSelf: "center",
            }}
          />
        </TableCell>
        <TableCell
          sx={{ cursor: "pointer" }}
          onClick={() => {
            setIdLocalEditing(producto.idLocal);
            setEditProductId(producto.idProducto);
          }}
        >
          <img
            src={producto.urlFoto}
            // src={"https://http2.mlstatic.com/D_NQ_NP_601375-MLA51645718227_092022-W.jpg"}
            alt={producto.nombre}
            style={{
              width: "100px",
              height: "100px",
            }}
          />
        </TableCell>
        <TableCell sx={{ fontSize: "15px" }}>
          {producto.nombreLocal} - {`(${producto.idLocal})`}
        </TableCell>
        <TableCell sx={{ fontSize: "15px" }}>
          {producto.nombre} - {`(${producto.idProducto})`}
        </TableCell>
        <TableCell width={"350px"}>
          <DesplegableRubrosProducto
            loading={loadingRubros}
            onChange={cambiarRubro}
            nombreRubro={producto.nombreRubro}
            rubros={rubros}
            idActual={producto.idRubro}
            setIsSelected={setIsSelected}
            isSelected={isSelected}
          />
        </TableCell>
        <TableCell sx={{ fontSize: "15px" }}>
          {producto.precioFormateado.split("<br>").map(
            (linea, i) =>
              linea.length > 0 && (
                <span key={i}>
                  {linea}
                  <br />
                </span>
              )
          )}
        </TableCell>
        <TableCell sx={{ fontSize: "15px", whiteSpace: "break-spaces" }}>
          {`Pub: ${format(
            new Date(producto.fechaPublicacion),
            "dd/MM/yyyy HH:mm"
          )}\nVto: ${format(
            new Date(producto.fechaVencimiento),
            "dd/MM/yyyy"
          )}`}
        </TableCell>
        <TableCell sx={{ fontSize: "15px" }}>{producto.flags}</TableCell>
        <TableCell>
          <ButtonDesplegable label="Acciones" className="d-flex flex-column">
            <ProductoActions
              changingEstado={changingEstado}
              isDefinitivelyDeleting={isDefinitivelyDeleting}
              producto={producto}
            />
          </ButtonDesplegable>
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableProducto;
